import type { Ref } from "react";

import { ActionIcon, Group } from "@mantine/core";

import { IconCircleMinus, IconGripVertical } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import ProceduresCodeBadge from "./ProceduresCodeBadge";

/** One selected diagnosis in the picker's right panel, with its remove button when removable. */
function SelectedDiagnosisRow({
  code,
  description,
  onRemove,
  isRemovable,
  removeButtonRef,
}: {
  code: string;
  description: string;
  onRemove: () => void;
  isRemovable: boolean;
  /** Lets the panel move focus back to this row after Undo restores it. */
  removeButtonRef?: Ref<HTMLButtonElement>;
}) {
  return (
    <Group
      px="sm"
      py="xs"
      gap="sm"
      bg="white"
      style={{ borderRadius: 8 }}
      bd="1px solid var(--mantine-color-cream-4)"
    >
      <ActionIcon
        size="sm"
        color="gray"
        variant="transparent"
        style={{ cursor: "grab" }}
        data-testid="grip-vertical-icon"
      >
        <IconGripVertical size={16} />
      </ActionIcon>
      <ProceduresCodeBadge code={code} />
      <TextWrapper flex={1}>{description}</TextWrapper>
      {isRemovable && (
        <ActionIcon
          size="sm"
          color="red"
          onClick={onRemove}
          variant="transparent"
          ref={removeButtonRef}
          aria-label="Remove diagnosis"
          data-testid={`remove-diagnosis-button-${code}`}
        >
          <IconCircleMinus size={20} />
        </ActionIcon>
      )}
    </Group>
  );
}

export default SelectedDiagnosisRow;
